import { useState } from "react";
import { FeedbackModal } from "../components/FeedbackModal/FeedbackModal";

export default function SidebarWidget() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div
        className={`
        mx-auto mb-10 w-full max-w-60 rounded-2xl bg-gray-50 px-4 py-5 text-center dark:bg-white/[0.03]`}
      >
        <h3 className="mb-2 font-semibold text-gray-900 dark:text-white text-h6">
          Help shape Casekeep
        </h3>
        <p className="mb-4 text-gray-500 text-theme-sm dark:text-gray-400">
          Your feedback directly influences what we build next.
        </p>
        <button
          onClick={() => setIsModalOpen(true)}
          className="flex items-center justify-center w-full p-3 font-medium text-white rounded-lg bg-brand-500 text-theme-sm hover:bg-brand-600"
        >
          Leave feedback
        </button>
      </div>

      <FeedbackModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
}
